import InputTagsSuggest from './InputTagsSuggest';

export default InputTagsSuggest;



// WEBPACK FOOTER //
// ./src/views/containers/InputTagsSuggest/index.js